<template>
  <div
    style="
      height: 100%;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      padding: 20px;
    "
  >
    <ul
      style="
        border: 1px solid #ebeef5;
        border-bottom: 0;
        padding: 10px;
        display: flex;
      "
    >
      <li style="display: flex; align-items: center; font-size: 13px; flex: 1">
        <text style="color: #a2a2a2">当前已选择：</text>
        <text style="color: #1e90ff; font-weight: 600">
          {{ props.data?.length || 0 }}
        </text>
        位员工
      </li>
      <li>
        <el-button
          type="primary"
          :icon="Edit"
          link
          @click="state.showSetDate = true"
        >
          批量设置离职时间
        </el-button>
        <el-button type="warning" :icon="Upload" link @click="onSubmit()">
          确定申报
        </el-button>
      </li>
    </ul>
    <el-table
      ref="tableDom"
      :data="state.tableData"
      v-loading="!Array.isArray(state.tableData)"
      element-loading-background="rgba(0, 0, 0, 0.2)"
    >
      <el-table-column
        fixed
        label="序号"
        width="50"
        type="index"
        align="center"
      />
      <el-table-column
        label="姓名"
        prop="name"
        sortable="name"
        :min-width="120"
        :formatter="$tab_TextFormat"
      />
      <el-table-column
        label="所属税期"
        prop="calc_tax_month"
        sortable="calc_tax_month"
        :min-width="120"
        :formatter="$tab_TextFormat"
      />
      <el-table-column
        label="算税状态"
        prop="status"
        sortable="status"
        :min-width="120"
      >
        <template #default="{ row }">
          <c_status
            arrName="payrollemployee_tax_status"
            :value="row.tax_status"
          />
        </template>
      </el-table-column>
      <el-table-column label="工资表" prop="payroll_name" :min-width="120" />
      <el-table-column
        label="算税单"
        prop="tax_name"
        sortable="status"
        :min-width="120"
      />
      <el-table-column
        label="手机号"
        prop="phone"
        sortable="phone"
        :min-width="120"
      />
      <el-table-column label="证件类型" prop="idtype" :min-width="120" />
      <el-table-column label="证件号" prop="idcard" :min-width="180" />
      <el-table-column
        label="扣缴义务人"
        prop="status"
        sortable="status"
        :min-width="200"
      >
        <template #default="{ row }">
          <div
            v-if="row.withholding_agent_id"
            :data-type="row.withholding_agent_type == 1 ? '供' : '扣'"
            :style="{
              '--dynamic-color':
                row.withholding_agent_type == 1 ? '#1e90ff' : '#ffa500',
            }"
            class="withholding-badge"
          >
            {{ row.withholding_agent_name }}
          </div>
          <text v-else>-</text>
        </template>
      </el-table-column>
      <el-table-column
        label="统一社会信用代码"
        prop="unified_social_credit_identifier"
        :min-width="160"
      />
      <el-table-column
        label="所属客户"
        prop="customer_name"
        sortable="customer_name"
        :min-width="200"
      />
      <el-table-column label="负责人" prop="belonger_name" :min-width="120" />
      <el-table-column
        label="属性"
        prop="property_name"
        sortable="property_name"
        :min-width="120"
      />
      <el-table-column
        label="入职日期"
        prop="entry_time"
        sortable="entry_time"
        :min-width="120"
      />
      <el-table-column
        label="离职日期"
        prop="resignation_time"
        sortable="resignation_time"
        :min-width="120"
        fixed="right"
        :formatter="$tab_TextFormat"
      />
      <el-table-column
        label="人员状态"
        prop="status_name"
        sortable="status_name"
        :min-width="120"
      />
      <el-table-column
        label="报送状态"
        prop="declare_status_name"
        sortable="declare_status_name"
        :min-width="120"
      />
      <el-table-column
        label="报送时间"
        prop="declare_time"
        sortable="declare_time"
        :min-width="180"
      />
      <el-table-column label="操作" width="150" align="center" fixed="right">
        <template #default="{ row }">
          <el-button
            type="warning"
            link
            icon="Upload"
            @click="
              state.selectItem = row;
              state.showSingleSetDate = true;
            "
          >
            设置离职日期
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      v-model="state.showSetDate"
      title="批量设置离职日期"
      width="300"
      align="center"
      align-center
      :show-close="false"
    >
      <div>
        <el-date-picker
          v-model="state.resignation_time"
          type="day"
          placeholder="离职日期"
          format="YYYY年M月D日"
          value-format="YYYY-MM-DD"
          style="width: 100%; margin-top: 20px"
          size="large"
        />
        <el-button
          type="primary"
          @click="onSetDate"
          size="large"
          style="width: 100%; margin-top: 30px"
        >
          确定设置
        </el-button>
      </div>
    </el-dialog>
    <el-dialog
      v-model="state.showSingleSetDate"
      :title="`设置员工${state.selectItem?.name}离职日期`"
      width="300"
      align="center"
      align-center
      :show-close="false"
    >
      <div>
        <el-date-picker
          v-model="state.single_resignation_time"
          type="day"
          placeholder="离职日期"
          format="YYYY年M月D日"
          value-format="YYYY-MM-DD"
          style="width: 100%; margin-top: 20px"
          size="large"
        />
        <el-button
          type="primary"
          @click="onSaveDate"
          size="large"
          style="width: 100%; margin-top: 30px"
        >
          确定设置
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import { uncalctaxemployee_resignationdeclares } from "@/http/uncalctaxemployee";
import { post_response } from "@/utils/qFormat";

export default {
  props: {
    data: Array,
  },
  setup(props, { emit }) {
    const state = reactive({});
    onMounted(() => {
      state.tableData = props.data;
    });

    const onSetDate = () => {
      state.tableData.forEach((e) => {
        e.resignation_time = state.resignation_time;
        state.showSetDate = false;
      });
    };

    const onSubmit = () => {
      var data = JSON.stringify(
        state.tableData.map((m) => {
          return { id: m.id, resignation_time: m.resignation_time };
        })
      );
      uncalctaxemployee_resignationdeclares(data).then((res) => {
        post_response(res, emit);
      });
    };

    const onSaveDate = () => {
      state.selectItem.resignation_time = state.single_resignation_time;
      state.showSingleSetDate = false;
    };
    return { state, props, onSetDate, onSubmit, onSaveDate };
  },
};
</script>
<style scoped></style>
